import { makeListGroupsComponent } from '../ListGroups';
import { ChannelDatum } from '../../types';

export const ChannelDataListGroups = makeListGroupsComponent<ChannelDatum>();
